import {customAxios} from "../customAxios";
import {useEffect, useState} from "react";
import {VehicleSimpleDto} from "../../model/Vehicle";

export function useGetVehicles() {
    const [loading, setLoading] = useState<boolean>(false);
    const [data, setData] = useState<VehicleSimpleDto[]>([]);
    const [error, setError] = useState<Error>();

    useEffect(() => {
        execute();
    }, []);
    async function execute() {
        try {
            setLoading(true);
            setError(undefined);
            const data = await getVehicles();
            setData(data);
            return data;
        }
        catch (e) {
            setError(e as Error);
            return Promise.reject(e);
        }
        finally {
            setLoading(false);
        }
    }

    return {
        loading, data, error, execute
    };
}

export async function getVehicles(): Promise<VehicleSimpleDto[]> {
    const response = await customAxios.get<VehicleSimpleDto[]>('/v1/vehicle', );
    return response.data;
}

